import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const languagesManagement = createApi({
    reducerPath: "languagesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        languageList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/languages`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewLanguage: builder.mutation({
            query: (languageId) => ({
                url: `v1/${locale}/settings/languages/${languageId}`,
                method: "GET",
            }),
        }),
        addLanguage: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/languages`,
                method: "POST",
                body: body,
            }),
        }),
        updateLanguage: builder.mutation({
            query: ({ body, languageId }) => ({
                url: `v1/${locale}/settings/languages/${languageId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteLanguage: builder.mutation({
            query: (languageId) => ({
                url: `v1/${locale}/settings/languages/${languageId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useLanguageListMutation, useViewLanguageMutation, useAddLanguageMutation, useUpdateLanguageMutation, useDeleteLanguageMutation } =
    languagesManagement;
